module.exports = __webpack_public_path__ + "img/clay.51df1150.png";